import React from 'react'
import { Grid, GridItem } from '@chakra-ui/react'
import { Subsection } from '../components/subsection'
import { ProbeVersions } from './probe-versions'
import { SoftwareUpload } from './software-upload'

export const Probe = () => {
    return (
        <Grid templateColumns="repeat(2, 1fr)" gap={6}>
            <GridItem>
                <Subsection title="Upload probe software">
                    <SoftwareUpload />
                </Subsection>
            </GridItem>

            <GridItem>
                <Subsection title="Available versions">
                    <ProbeVersions />
                </Subsection>
            </GridItem>
        </Grid>
    )
}
